import { render, staticRenderFns } from "./SalesButton.vue?vue&type=template&id=3513f53a&"
import script from "./SalesButton.vue?vue&type=script&lang=js&"
export * from "./SalesButton.vue?vue&type=script&lang=js&"
import style0 from "./SalesButton.vue?vue&type=style&index=0&id=3513f53a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports